<template>
  <iframe
    id="frame-content"
    :src="link"
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    allowfullscreen="true"
  >
  </iframe>
</template>

<script>
function resizeContentHeight(elem, resizeElem, type) {
  let scrollHeughtFrame = elem.contentWindow.document.body.scrollHeight;
  if (scrollHeughtFrame <= resizeElem.offsetHeight) return;
  if (type === "lab") return;
  elem.style.height = scrollHeughtFrame + 100 + "px";
}

export default {
  name: "FrameComponent",
  computed: {
    link() {
      return this.$store.getters.CONTENT(this.$route.path).content;
    },
    type() {
      return this.$store.getters.CONTENT(this.$route.path).type;
    }
  },
  mounted() {
    setTimeout(_ => {
      if (this.type === "lab") {
        this.includeSript(
          "http://edu.jinr.ru/nucl-phys-for-school/data/labs/js/labFrameFunctions.js"
        );
      }

      resizeContentHeight(this.$el, this.$parent.$el, this.type);
    }, 1000);
  },
  methods: {
    includeSript: url => {
      var script = document.createElement("script");
      script.src = url;
      document.head.appendChild(script);
    }
  }
};
</script>

<style lang="scss" scoped>
#frame-content {
  width: 100%;
  border: 0;
  height: 100%;
  overflow-y: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/FrameComponent.vue